import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-and-security',
  templateUrl: './privacy-and-security.component.html',
  styleUrls: ['./privacy-and-security.component.css']
})
export class PrivacyAndSecurityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
